import { normalizeNickname } from "../../shared/nickname.js";

/**
 * 監督者自己填的名字，存在他自己的裝置上。
 *
 * 不進 D1：伺服器沒有「這台裝置是誰」的概念，暱稱是每次戳的時候一起送過去的。
 * 代價是**換裝置要重填**，這是接受的取捨——為了記住它而做帳號系統，
 * 就把一個個人 App 推成了多使用者系統。
 */
const NICKNAME_KEY = "fight-health-nickname-v1";

/** 存進去之後規則才改嚴的話，舊值可能不合規，所以讀出來也要驗一次。 */
export function loadNickname(): string {
  try {
    return normalizeNickname(localStorage.getItem(NICKNAME_KEY)) || "";
  } catch {
    return "";
  }
}

export function saveNickname(nickname: string): void {
  localStorage.setItem(NICKNAME_KEY, nickname);
}
